<script>
    import { Empty } from 'ant-design-vue';

    export default {
        name: 'ComponentsEmpty',
        props: {
            image: { type: String, default: 'images/sys-tip/empty.png' },
            description: { type: String, default: '' },
            imageStyle: { type: Object, default: () => {} },
            pStyle: { type: Object, default: () => {} },
            status: { type: Number, default: 1 }, // 0 暂无数据, 1 加载中
        },
        render() {
            let image = 'images/sys-tip/empty.png';
            let description = this.description || this.$t('center.personnel_nodata');
            if (this.status === 1) {
                image = 'images/sys-tip/loading.gif';
                description = this.$t('center.personnel_loading');
            }
            return (
                <div class="empty-wrapper" style={this.pStyle}>
                    <Empty description={description} image={image} imageStyle={this.imageStyle}/>
                </div>
            );
        }
    };
</script>
